export const FETCH_RELATIONS = 'fetchRelations';
export const FIND_RELATION = 'findRelation';
export const DELETE_RELATION = 'deleteRelation';
export const DELETE_CHILDREN_RELATION = 'deleteChildrenRelation';
export const CREATE_RELATION = 'createRelation';
export const UPDATE_RELATION = 'updateRelation';
export const CLEAR_RELATIONS = 'CLEAR_RELATIONS';
export const CREATE_SCENE_DICT = 'generateSceneDict';
export const UPDATE_SCENE_DICT = 'UPDATE_SCENE_DICT';
